<div class="content-canvas">
  <div class="myChart">
    <canvas id="canvas">{{chart}}</canvas>
  </div>
</div>